import React from 'react';
import { IMenuItemResponce } from '../../../../../../Interfaces/responseTypes';
import styles from './itemInfoDialog.module.scss'
import { useNoAuthHooks } from '../../../../../../Hooks/hooks';
import useLanguagesHooks from '../../../../../../Components/Languages/setLanguage-hooks';

interface IProps {
    data: IMenuItemResponce,
    title: string,
    currencySymbol: string
};

const ItemInfoDialog: React.FC<IProps> = ({ data, title, currencySymbol }) => {
    const {baseURL,renderOptions} = useNoAuthHooks();
    const {t,activeLanguage} = useLanguagesHooks();
    const localizedTitle = data[`name_${activeLanguage}` as keyof IMenuItemResponce] || data.name_en;
    const localizedDescription = data[`description_${activeLanguage}` as keyof IMenuItemResponce] || data.name_en;

    return (
        <div className={styles.container}>
            <img src={`${baseURL}${data.image}`} className={styles.image} alt='image.png' />
            <div className={styles.infoBox}>
                <div className={styles.body}>
                    <div className={styles.info}>
                        <div className={styles.itemTitle}>
                            <p>
                                {String(localizedTitle)}
                            </p>
                        </div>
                        {
                            data[`description_${activeLanguage}` as keyof IMenuItemResponce]
                            &&
                            <div className={styles.description}>
                                <p>
                                    {String(localizedDescription)}
                                </p>
                            </div>
                        }
                    </div>
                    <div className={styles.optionsBox}>
                        <div className={styles.optionsBoxTitle}>
                            <p>
                                {t("Visitor.Options_Title")}
                            </p>
                        </div>
                        {
                            data.option.map((item) => {
                                return (
                                    <div className={styles.optionRow} key={item.option_id}>
                                        <p className={styles.optionType}>
                                            {renderOptions(item)}
                                        </p>
                                        <div className={styles.optionPrice}>
                                            <p>
                                                {parseInt(item.price)}
                                            </p>
                                            <p>
                                                {currencySymbol}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItemInfoDialog
